export default __webpack_public_path__ + "static/logo-921b304cbb1af96ec4a52158da5b231d.jpg";